export default __webpack_public_path__ + "static/media/Prompt-Bold.59ab86e4.ttf";